import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';

const ThankYouPage: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Auto redirect after 10 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 10000);
    
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <motion.div
        className="bg-white rounded-lg shadow-lg p-8 max-w-lg w-full text-center"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex justify-center mb-6">
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: 1.2 }}
            transition={{ duration: 1, repeat: Infinity, repeatType: 'reverse' }}
          >
            <Heart size={48} className="text-red-500 fill-current" />
          </motion.div>
        </div>
        
        <h1 className="text-3xl font-playfair font-semibold text-wedding-blue-800 mb-4">
          Obrigado!
        </h1>
        
        <p className="text-gray-700 mb-6">
          Agradecemos por compartilhar esse momento especial conosco. Sua presença ou seu presente significam muito para nós.
        </p>
        
        <div className="w-24 h-0.5 bg-wedding-beige-400 mx-auto mb-6"></div>
        
        <p className="text-wedding-blue-700 font-medium italic mb-8">
          "O amor é paciente, o amor é bondoso... Tudo sofre, tudo crê, tudo espera, tudo suporta."
        </p>
        
        <button
          onClick={() => navigate('/')}
          className="px-6 py-3 bg-wedding-blue-600 text-white rounded-md hover:bg-wedding-blue-700 transition-colors"
        >
          Voltar para o Início
        </button>
        
        <p className="text-sm text-gray-500 mt-6">
          Você será redirecionado automaticamente em alguns segundos...
        </p>
      </motion.div>
    </div>
  );
};

export default ThankYouPage;